import { ContentUserContext } from '../../../context/3catinfo/ContentUserProvider';
import { useContext } from 'react';

export const useLaMevaLlista = () => {
    return useContext(ContentUserContext);
};
